import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyD4ujxwzXGU922dzxupYu4u2tXuhTUizVE",
    authDomain: "ewa-osk.firebaseapp.com",
    projectId: "ewa-osk",
    storageBucket: "ewa-osk.appspot.com",
    messagingSenderId: "743723529998",
    appId: "1:743723529998:web:309bd92b718d621982095f",
    measurementId: "G-7EGTZWV80K"
};

const analytics = null;

class WebPushService {


    constructor() {
        const app = initializeApp(firebaseConfig);
        this.analytics = getAnalytics(app);
    }

    eventLog(event) {
        console.log(this.analytics)
        if (this.analytics) {
            logEvent(this.analytics, event, {
                payload: "7276875768",
            });

            console.log("Log event " + event)
        }
    }
}

export default new WebPushService({})


// WEBPACK FOOTER //
// ./src/services/Analytics.js